<script>import { getSrcSet } from "./image.helpers";
export let image;
export let src = undefined;
export let srcset = undefined;
export let noWebp = undefined;
export let aspectRatio = undefined;
export let highPriority = undefined;
export let altText = undefined;
export let backgroundPosition = undefined;
export let backgroundSize = undefined;
export let className = undefined;
export let sizes = undefined;
export let builderBlock = undefined;
export let fitContent = undefined;
function stringifyStyles(stylesObj) {
    let styles = "";
    for (let key in stylesObj) {
        const dashedKey = key.replace(/[A-Z]/g, function (match) {
            return "-" + match.toLowerCase();
        });
        styles += dashedKey + ":" + stylesObj[key] + ";";
    }
    return styles;
}
$: srcSetToUse = () => {
    const imageToUse = image || src;
    const url = imageToUse;
    if (!url ||
        // We can auto add srcset for cdn.builder.io and shopify
        // images, otherwise you can supply this prop manually
        !(url.match(/builder\.io/) || url.match(/cdn\.shopify\.com/))) {
        return srcset;
    }
    if (srcset && image?.includes("builder.io/api/v1/image")) {
        if (!srcset.includes(image.split("?")[0])) {
            console.debug("Removed given srcset");
            return getSrcSet(url);
        }
    }
    else if (image && !srcset) {
        return getSrcSet(url);
    }
    return getSrcSet(url);
};
$: webpSrcSet = () => {
    if (srcSetToUse?.()?.match(/builder\.io/) && !noWebp) {
        return srcSetToUse().replace(/\?/g, "?format=webp&");
    }
    else {
        return "";
    }
};
$: aspectRatioCss = () => {
    const aspectRatioStyles = {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: "0px",
        top: "0px",
    };
    const out = aspectRatio ? aspectRatioStyles : undefined;
    return out;
};
</script>

<picture>
  {#if webpSrcSet()}
    <source type="image/webp" srcset={webpSrcSet()} />
  {/if}<img
    style={stringifyStyles({
      objectPosition: backgroundPosition || "center",
      objectFit: backgroundSize || "cover",
      ...aspectRatioCss(),
    })}
    loading={highPriority ? "eager" : "lazy"}
    fetchpriority={highPriority ? "high" : "auto"}
    alt={altText}
    role={altText ? undefined : "presentation"}
    class={"builder-image" + (className ? " " + className : "") + " img"}
    src={image}
    srcset={srcSetToUse()}
    {sizes}
  /></picture
>

{#if aspectRatio && !(builderBlock?.children?.length && fitContent)}
  <div
    style={stringifyStyles({
      paddingTop: aspectRatio * 100 + "%",
    })}
    class="builder-image-sizer div"
  />
{/if}

{#if builderBlock?.children?.length && fitContent}
  <slot />
{/if}

{#if !fitContent && builderBlock?.children?.length}
  <div class="div-2"><slot /></div>
{/if}

<style>
  .img {
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
  }
  .div {
    width: 100%;
    pointer-events: none;
    font-size: 0;
  }
  .div-2 {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>